import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getAllIssuanceType } from '../../../store/slices/issuanceType';
import YesNoDialog from '../../../components/yes-no-dialog';
import TableHeader from "./table-header";
import TableBody from "./table-body";
import { updateAgentIssuanceAPI, updateDefaultAgentIssuanceTypeAPI } from '../../../services/api';
import Notify from '../../../components/notify';

const IssuanceTypeList = () => {
  const [deactivateDialog, setDeactivateDialog] = useState(false);
  const [defaultDialog, setDefaultDialog] = useState(false);
  const [openNotification, setOpenNotification] = useState(false);
  const [issuanceTypes, setIssuanceTypes] = useState([]);
  const [issuanceTypesFilter, setIssuanceTypesFilter] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedIssuanceTypeId, setSelectedIssuanceTypeId] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  const loadingReducer = useSelector((state) => state.issuanceType.loading);
  const issuanceTypesReducer = useSelector((state) => state.issuanceType.issuanceTypes);

  useEffect(() => {
    dispatch(getAllIssuanceType());
  }, []);

  useEffect(() => {
    setIssuanceTypes(issuanceTypesReducer || []);
    setIssuanceTypesFilter(issuanceTypesReducer || []);
    setLoading(loadingReducer);
  }, [loading, issuanceTypesReducer]);

  const handleSearch = (val) => {
    const searchText = val?.trim()?.toLowerCase() || '';
    const filteredRow = [];

    issuanceTypes.forEach((issuanceType) => {
      const id = issuanceType?.id?.toLowerCase() || '';
      const name = issuanceType?.name?.toLowerCase() || '';

      if (
        id.includes(searchText) ||
        name.includes(searchText)
      ) {
        filteredRow.push(issuanceType);
      }
    });
    setIssuanceTypesFilter(filteredRow);
  }

  const toggleDeactivateModal = (val, issuanceTypeId) => {
    setDeactivateDialog(val);
    if (issuanceTypeId) {
      setSelectedIssuanceTypeId(issuanceTypeId);
    }
  }

  const handleDeactivate = async () => {
    try {
      setLoading(true);
      const payload = {
        status: 0
      }
      const response = await updateAgentIssuanceAPI(selectedIssuanceTypeId, payload);
      dispatch(getAllIssuanceType());
      setErrors({});
      setLoading(false);
      setOpenNotification(true);
      toggleDeactivateModal(false);
      setSuccessMessage(`Issuance Type "${response?.name}" has been deactivated.`);
    } catch (err) {
      const errors =
        err && Object.keys(err).length > 0
          ? err
          : { errormessage: 'Deactivating Issuance Type Failed !!!!' };
      setErrors(errors);
      setOpenNotification(true);
      toggleDeactivateModal(false);
      setLoading(false);
    }
  }

  const toggleDefaultModal = (val, issuanceTypeId) => {
    setDefaultDialog(val);
    if (issuanceTypeId) {
      setSelectedIssuanceTypeId(issuanceTypeId);
    }
  }

  const handleDefault = async () => {
    try {
      setLoading(true);
      await updateDefaultAgentIssuanceTypeAPI(selectedIssuanceTypeId);
      dispatch(getAllIssuanceType());
      setErrors({});
      setLoading(false);
      setOpenNotification(true);
      toggleDefaultModal(false);
      setSuccessMessage(`Default issuance type updated.`);
    } catch (err) {
      const errors =
        err && Object.keys(err).length > 0
          ? err
          : { errormessage: 'Updating default issuance type failed !!!!' };
      setErrors(errors);
      setOpenNotification(true);
      toggleDefaultModal(false);
      setLoading(false);
    }
  }

  const selectedIssuanceType = issuanceTypes.find(i => i.id === selectedIssuanceTypeId);

  return (
    <>
      <TableHeader handleSearch={handleSearch} />
      <TableBody
        users={issuanceTypesFilter}
        openDeactivateModal={toggleDeactivateModal}
        openDefaultModal={toggleDefaultModal}
      />
      <YesNoDialog
        openDialog={deactivateDialog}
        message={'Are you sure that you want to deactivate this issuance type? This action cannot be undone.'}
        handleCloseDialog={() => toggleDeactivateModal(false)}
        handleYes={handleDeactivate}
      />
      <YesNoDialog
        openDialog={defaultDialog}
        message={`Set ${selectedIssuanceType?.name} as default issuance type for department ${selectedIssuanceType?.department?.name}?`}
        handleCloseDialog={() => toggleDefaultModal(false)}
        handleYes={handleDefault}
      />
      <Notify
        open={openNotification}
        onClose={() => setOpenNotification(false)}
        successMessage={successMessage}
        errors={errors}
      />
    </>
  );
}

export default IssuanceTypeList;